import FeedbackDialog from './feedback-dialog';

export { FeedbackDialog };

export default FeedbackDialog;
